import { routes } from "@/router/constants";
import { IS_DEV } from "@/utils/constant";

interface NavLinkItem {
  title: string;
  icon?: React.FC;
  path?: string;
  redirect?: string;
  action?: "navigate" | "api-get"; // 'navigate' = default, 'api-get' = send GET request
  apiUrl?: string; // API endpoint for 'api-get' action
  hidden?: boolean;
}

export interface NavLink extends NavLinkItem {
  subMenu?: NavLinkItem[];
}
export type VerticalNavItemsType = NavLink[];

const navigation = ({ isConnected }): VerticalNavItemsType => [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "Explore",
    path: "/explore",
  },
  // {
  // 	title: "Swap",
  // 	redirect: "https://swap.monbase.com",
  // },
  // {
  //   title: "Vesting",
  //   path: "/vesting",
  //   hidden: !isConnected,
  // },
  // {
  //   title: "Reward",
  //   path: "/reward",
  // },
  {
    title: "Stats",
    subMenu: [
      {
        title: "Ranking",
        path: "/ranking",
      },
      {
        title: "Activities",
        path: "/activities",
      },
    ],
  },
  {
    title: "Create",
    subMenu: [
      {
        title: "NFT",
        path: routes.CREATE_NFT,
      },
      {
        title: "Collection",
        path: routes.CREATE_COLLECTION,
      },
    ],
  },
  {
    title: "Lottery",
    path: routes.LOTTERY,
  },
  {
    title: "Lucky Draw",
    path: routes.LUCKY_DRAW,
  },
  // {
  // 	title: "Launchpad",
  // 	path: routes.LAUNCHPAD,
  // },
  {
    title: "SANH",
    path: routes.SanhPackage,
    hidden: false,
  },
  {
    title: "Swap",
    path: routes.SWAP,
  },
  {
    title: "BCC",
    path: "/bcc",
    action: "api-get",
    apiUrl: "/bcc", // API endpoint to call
  },
];

export default navigation;
